import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { routes } from "./routes";
import axios from "axios";
import Vue2Filters from "vue2-filters";
import ReadOnlyField from "./components/common/ReadOnlyField";
import DetailHeader from "./components/common/DetailHeader";
import UnderConstruction from "./components/common/UnderConstruction";
import TableEx from "./components/common/TableEx";
import NoDataMessage from "./components/common/NoDataMessage";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueCookies from "vue-cookies";
import { store } from "./store/store";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "babel-polyfill";

axios.defaults.baseURL = "/api";

Vue.use(VueRouter);
Vue.use(Vue2Filters);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);

Vue.component("app-readonly-field", ReadOnlyField);
Vue.component("app-detail-header", DetailHeader);
Vue.component("app-under-construction", UnderConstruction);
Vue.component("app-table-ex", TableEx);
Vue.component("app-no-data", NoDataMessage);

const router = new VueRouter({
  mode: "history",
  routes,
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !(error.config && error.config.url && error.config.url.includes("/auth/"))
    ) {
      localStorage.removeItem("user");
      store.dispatch("login/signOut");
      router.push({
        path: "/login",
        query: { expired: "true" },
      });
    }
    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
  const publicPaths = ["/login", "/register", "/activate", "/recover", "/reactivate", "/reset", "/"];
  const isPublic = publicPaths.includes(to.path);
  const userStr = localStorage.getItem("user");
  let hasToken = false;
  let hadSession = false;
  try {
    const user = userStr ? JSON.parse(userStr) : null;
    hadSession = !!userStr;
    hasToken = user && user.accessToken;
  } catch (e) {
    localStorage.removeItem("user");
    hadSession = true;
  }
  if (!isPublic && !hasToken) {
    next({ path: "/login", query: hadSession ? { expired: "true" } : {} });
  } else {
    next();
  }
});

// On startup, validate session and refresh user data from the current database
const savedUserStr = localStorage.getItem("user");
if (savedUserStr) {
  try {
    const savedUser = JSON.parse(savedUserStr);
    if (savedUser && savedUser.accessToken) {
      axios
        .get("/user/me", {
          headers: { Authorization: "Bearer " + savedUser.accessToken },
        })
        .then((response) => {
          const freshUser = response.data;
          // Update localStorage with fresh data from server, keep existing token
          const updatedUser = {
            username: freshUser.username,
            accessToken: savedUser.accessToken,
            firstName: freshUser.firstName,
            lastName: freshUser.lastName,
            role: freshUser.role,
            associatedPartyIds: freshUser.associatedPartyIds,
            addedPartyIds: freshUser.addedPartyIds,
          };
          localStorage.setItem("user", JSON.stringify(updatedUser));
          store.dispatch("login/setSession", updatedUser);
        })
        .catch(() => {
          // 401 is handled by the interceptor (redirects to login)
        });
    }
  } catch (e) {
    localStorage.removeItem("user");
  }
}

new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js